export default "__VITE_ASSET__xJcfnIVK__"